import axios from "axios"
import { API } from "../config"

const api = axios.create({
  baseURL: API
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token")
      localStorage.removeItem("role")
    }
    return Promise.reject(error)
  }
)

export const get = (url, config) => api.get(url, config)
export const post = (url, data, config) => api.post(url, data, config)
export const put = (url, data, config) => api.put(url, data, config)
export const del = (url, config) => api.delete(url, config)

export const loginUser = (data) => api.post("/auth/login", data)
export const registerUser = (data) => api.post("/auth/register", data)
export const getMe = () => api.get("/auth/me")

export const getDashboard = () => api.get("/seo/dashboard")

export const getUsers = () => api.get("/admin/users")
export const createUser = (data) => api.post("/admin/users", data)
export const updateUserRole = (id, role) =>
  api.put(`/admin/users/${id}/role`, { role })
export const toggleUserStatus = (id) => api.put(`/admin/users/${id}/toggle`)
export const deleteUser = (id) => api.delete(`/admin/users/${id}`)

export const getPlans = () => api.get("/plans")
export const createPlan = (data) => api.post("/plans", data)
export const updatePlan = (id, data) => api.put(`/plans/${id}`, data)
export const deletePlan = (id) => api.delete(`/plans/${id}`)

export const generateContent = (data) =>
  api.post("/seo/ai-content", {
    keyword: data.keyword || data.topic,
    type: data.type || "article"
  })

export const getAISEO = (domain) =>
  api.get("/seo/ai", { params: { domain } })

export const getAutopilot = (domain) =>
  api.get("/seo/autopilot", { params: { domain } })

export const getGraph = (domain) =>
  api.get("/seo/graph", { params: { domain } })

export const getBacklinks = (domain) =>
  api.get("/seo/backlinks", { params: { domain } })

export const getCompetitors = (domain) =>
  api.get("/seo/competitors", { params: { domain } })

export const getKeywords = (domain) =>
  api.get("/seo/keywords", { params: { domain } })

export const getRank = (domain, keyword) =>
  api.get("/seo/rank", { params: { domain, keyword } })

export default api
